<template>
  <div class="ui container">
    <h1 class="ui center aligned header">
      {{ activePlayer.name }} is aan de beurt
    </h1>

    <div
      class="ui center aligned very padded segment"
      :class="{ attached: isHost }"
    >
      <div class="ui huge statistic">
        <div class="value">{{ activePlayer.score }}</div>
        <div class="label">{{ activePlayer.name }}</div>
      </div>
    </div>

    <div
      class="ui massive orange bottom attached button"
      id="start-player-turn"
      :class="{ loading, disabled: loading }"
      @click.once="startQuestion"
      v-if="isHost"
    >
      Start [ENTER]
    </div>

    <div class="ui center aligned info-text segment" v-if="infoText && isHost">
      <h1 class="ui header">{{ infoText }}</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROUNDS } from '../config';
import Mousetrap from 'mousetrap';

export default {
  name: 'players-turn',
  data() {
    return {
      infoText: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters(['activePlayer', 'isHost', 'inFinale', 'inGalerij'])
  },
  created() {
    if (this.inFinale) {
      this.infoText = this.$store.getters[
        `${ROUNDS[this.$store.state.game.currentRound].slug}/activeQuestion`
      ].question;
    } else if (this.inGalerij) {
      this.infoText =
        'Thema: ' +
        this.$store.getters[
          `${ROUNDS[this.$store.state.game.currentRound].slug}/activeQuestion`
        ].theme;
    }
    this.addKeyboardShortcuts();
  },
  methods: {
    startQuestion() {
      this.loading = true;
      this.$store
        .dispatch(
          `${ROUNDS[this.$store.state.game.currentRound].slug}/startQuestion`
        )
        .then(() => {
          this.$store.dispatch('syncGame');
          this.loading = false;
        });
    },
    addKeyboardShortcuts() {
      Mousetrap.bind('enter', () => {
        const startButton = document.querySelector('#start-player-turn');
        if (startButton) startButton.click();
        return false;
      });
    }
  }
};
</script>

<style scoped>
.ui.statistic > .value {
  font-size: 12rem !important;
}
.ui.statistic > .label {
  font-size: 2.5rem !important;
}
h1.ui.header {
  font-size: 2rem;
}
h2.ui.header {
  font-size: 2rem;
}
.info-text h1.ui.header {
  margin-top: 0.15rem;
}
</style>
